var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 3c-3-4-9-4-12 0l-7 7c-1 2-4 3-6 3l-9-1c-5 0-9 4-9 9l1 9c0 2-1 5-3 6l-7 7c-4 3-4 9 0 12l7 7c2 1 3 4 3 6l-1 9c0 5 4 9 9 9l9-1c2 0 5 1 6 3l7 7c3 4 9 4 12 0l6-7c2-2 5-3 7-3l9 1c5 0 9-4 9-9l-1-9c0-2 1-5 3-6l7-7c4-3 4-9 0-12l-7-7c-2-1-3-4-3-6l1-9c0-5-4-9-9-9l-9 1c-2 0-5-1-7-3l-6-7Zm-6 63a17 17 0 1 0 0-34 17 17 0 0 0 0 34Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIconLight);
export default __webpack_public_path__ + "static/media/settings-icon-light.690a94fb8448d03806e60285542dd137.svg";
export { ForwardRef as ReactComponent };